import { render, staticRenderFns } from "./SoFile.vue?vue&type=template&id=a0a44a90&scoped=true&"
import script from "./SoFile.vue?vue&type=script&lang=js&"
export * from "./SoFile.vue?vue&type=script&lang=js&"
import style0 from "./SoFile.vue?vue&type=style&index=0&id=a0a44a90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a44a90",
  null
  
)

export default component.exports